import { DivisionIcon } from './DivisionIcon';

/**
 * author: Austin Andrews
 * id FB313489-5EA3-4F07-ABA4-F84995D7DD13
 * name division
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/division.svg
 * tags
 * - Math 
 */
export const ObelusIcon = DivisionIcon;
export default ObelusIcon